export function shouldShowPropertyUnavailable({
  isDetailRequestFailed,
  isRented,
  isSharedHashLink,
}: {
  isDetailRequestFailed: boolean;
  isRented: unknown;
  isSharedHashLink: boolean;
}): boolean {
  if (isDetailRequestFailed) {
    return true;
  }

  return Boolean(isRented) && !isSharedHashLink;
}

export function getUnavailableSimilarPropertiesSource(
  isDetailRequestFailed: boolean
): "related" | "featured" {
  return isDetailRequestFailed ? "featured" : "related";
}
